/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf7 } from './AssistantChatPostRequestMessagePartsInnerAnyOf7';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOf7FromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf7FromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOf7ToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf7ToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf7';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf } from './AssistantChatPostRequestMessagePartsInnerAnyOf';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOfFromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOfFromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOfToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOfToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf1 } from './AssistantChatPostRequestMessagePartsInnerAnyOf1';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOf1FromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf1FromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOf1ToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf1ToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf1';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf2 } from './AssistantChatPostRequestMessagePartsInnerAnyOf2';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOf2FromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf2FromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOf2ToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf2ToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf2';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf3 } from './AssistantChatPostRequestMessagePartsInnerAnyOf3';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOf3FromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf3FromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOf3ToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf3ToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf3';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf4 } from './AssistantChatPostRequestMessagePartsInnerAnyOf4';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOf4FromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf4FromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOf4ToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf4ToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf4';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf5 } from './AssistantChatPostRequestMessagePartsInnerAnyOf5';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOf5FromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf5FromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOf5ToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf5ToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf5';
import type { AssistantChatPostRequestMessagePartsInnerAnyOf6 } from './AssistantChatPostRequestMessagePartsInnerAnyOf6';
import {
    AssistantChatPostRequestMessagePartsInnerAnyOf6FromJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf6FromJSONTyped,
    AssistantChatPostRequestMessagePartsInnerAnyOf6ToJSON,
    AssistantChatPostRequestMessagePartsInnerAnyOf6ToJSONTyped,
} from './AssistantChatPostRequestMessagePartsInnerAnyOf6';

/**
 * 
 * @export
 * @interface AssistantChatPostRequestMessagePartsInner
 */
export interface AssistantChatPostRequestMessagePartsInner {
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    text: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    providerMetadata?: { [key: string]: object; };
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    toolCallId: string;
    /**
     * 
     * @type {any}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    input: any | null;
    /**
     * 
     * @type {any}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    output?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    callProviderMetadata?: any | null;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    mediaType: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    filename?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    sourceId: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    id?: string;
    /**
     * 
     * @type {any}
     * @memberof AssistantChatPostRequestMessagePartsInner
     */
    data: any | null;
}

/**
 * Check if a given object implements the AssistantChatPostRequestMessagePartsInner interface.
 */
export function instanceOfAssistantChatPostRequestMessagePartsInner(value: object): value is AssistantChatPostRequestMessagePartsInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('toolCallId' in value) || value['toolCallId'] === undefined) return false;
    if (!('input' in value) || value['input'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('mediaType' in value) || value['mediaType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('sourceId' in value) || value['sourceId'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function AssistantChatPostRequestMessagePartsInnerFromJSON(json: any): AssistantChatPostRequestMessagePartsInner {
    return AssistantChatPostRequestMessagePartsInnerFromJSONTyped(json, false);
}

export function AssistantChatPostRequestMessagePartsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantChatPostRequestMessagePartsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'text': json['text'],
        'providerMetadata': json['providerMetadata'] == null ? undefined : json['providerMetadata'],
        'state': json['state'],
        'toolCallId': json['toolCallId'],
        'input': json['input'],
        'output': json['output'] == null ? undefined : json['output'],
        'callProviderMetadata': json['callProviderMetadata'] == null ? undefined : json['callProviderMetadata'],
        'url': json['url'],
        'mediaType': json['mediaType'],
        'filename': json['filename'] == null ? undefined : json['filename'],
        'title': json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'sourceId': json['sourceId'],
        'id': json['id'] == null ? undefined : json['id'],
        'data': json['data'],
    };
}

export function AssistantChatPostRequestMessagePartsInnerToJSON(json: any): AssistantChatPostRequestMessagePartsInner {
    return AssistantChatPostRequestMessagePartsInnerToJSONTyped(json, false);
}

export function AssistantChatPostRequestMessagePartsInnerToJSONTyped(value?: AssistantChatPostRequestMessagePartsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'text': value['text'],
        'providerMetadata': value['providerMetadata'],
        'state': value['state'],
        'toolCallId': value['toolCallId'],
        'input': value['input'],
        'output': value['output'],
        'callProviderMetadata': value['callProviderMetadata'],
        'url': value['url'],
        'mediaType': value['mediaType'],
        'filename': value['filename'],
        'title': value['title'],
        'description': value['description'],
        'sourceId': value['sourceId'],
        'id': value['id'],
        'data': value['data'],
    };
}

